export default __webpack_public_path__ + "static/media/qr-icon.12f12a8f.png";